<mat-form-field floatLabel="never" class="search-bar" [class.fixed]="fixedSize">
  <input matInput [placeholder]="placeholder | translate"
         (focusin)="searchBarFocused = true"
         (focusout)="searchBarFocused = false"
         (keyup)="textChange.emit($event.target.value)"
         (keydown.enter)="textSubmit.emit($event.target.value)"
  >
  <mat-icon matSuffix class="search-icon" [class.focused]="searchBarFocused">search</mat-icon>
</mat-form-field>
